export function toArray(arr = []) {
  return Array.prototype.slice.call(arr, 0);
}



// WEBPACK FOOTER //
// ./assets/scripts/utils/toArray.js